import React from "react";
import { Styles } from "./styles";
import { Rating } from "@mui/material";

const ReviewOnServiceCard = ({ data }) => {
  return (
    <Styles>
      <a href={data?.panal_url} target="_blank" rel="noopener noreferrer">
        <div className="title-container">
          <a
            href={data?.panal_url}
            className="description block font-semibold"
          >
            panel url: {data?.panal_url}
          </a>
          <div className="rate">
            {" "}
            <Rating value={data?.rate} readOnly sx={{ fontSize: "1rem" }} />
            <div className="username">{data?.user_name}</div>
          </div>
        </div>
        <div className="inner-container">
          <div className="data">
            <div className="description">service id: {data?.service_id}</div>
            <div className="description">name: {data?.name}</div>
          </div>
          <div className="data end">
            <div className="description">title: {data?.title}</div>
            <div className="description">subject: {data?.subject}</div>
          </div>
        </div>
      </a>
    </Styles>
  );
};

export default ReviewOnServiceCard;
